module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "3.5em",
      "width": "3.5em",
      "float": "right"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })])])]), _vm._v(" "), _c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.inventoryNegativeStockLists,
      "paginator": true,
      "rowsPerPageOptions": [100, 500, 1000],
      "rows": 100,
      "filters": _vm.filters,
      "editMode": "cell"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n           " + _vm._s(sl.index + 1) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "headerStyle": "width: 16em",
      "header": "Item Name",
      "field": "itemName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['itemName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'itemName', $$v)
            },
            expression: "filters['itemName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Code",
      "field": "itemCode",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['itemCode']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'itemCode', $$v)
            },
            expression: "filters['itemCode']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit",
      "field": "unit",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['unit']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'unit', $$v)
            },
            expression: "filters['unit']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Store",
      "field": "warehouseName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['warehouseName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'warehouseName', $$v)
            },
            expression: "filters['warehouseName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Closing Stock",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "closingQuantity",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['closingQuantity']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'closingQuantity', $$v)
            },
            expression: "filters['closingQuantity']"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4489779c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/inventoryReports/itemNegativeStock.vue
// module id = 2184
// module chunks = 0